// extracted by mini-css-extract-plugin
module.exports = {"billImage":"Billing_billImage__1R2s5"};